"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = anonymous;

var _ikeaComponentButton = _interopRequireDefault(require("@ikea-aoa/ikea-component-button"));

var _ikeaComponentKeyboard = _interopRequireDefault(require("@ikea-aoa/ikea-component-keyboard"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function anonymous(locals, escapeFn, include, rethrow) {
  escapeFn = escapeFn || function (markup) {
    return markup == undefined ? '' : String(markup).replace(_MATCH_HTML, encode_char);
  };

  var _ENCODE_HTML_RULES = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&#34;",
    "'": "&#39;"
  },
      _MATCH_HTML = /[&<>'"]/g;

  function encode_char(c) {
    return _ENCODE_HTML_RULES[c] || c;
  }

  ;
  ;
  var __output = "";

  function __append(s) {
    if (s !== undefined && s !== null) __output += s;
  }

  ;

  if (_ikeaComponentButton.default.componentName) {
    this.registerComponentToManager(_ikeaComponentButton.default);
  }

  if (_ikeaComponentKeyboard.default.componentName) {
    this.registerComponentToManager(_ikeaComponentKeyboard.default);
  }

  ;

  __append("\n<div class=\"LoadVpc");

  __append(escapeFn(this.hasError ? ' LoadVpc--error' : ''));

  __append("\">\n    ");

  if (this.isLocalizationLoaded) {
    ;

    __append("\n        <div class=\"LoadVpc__title\">");

    __append(escapeFn(this.props.title || this.translate('SPR_GALLERY_OR_OPEN_SAVED_DESIGN')));

    __append("</div>\n        <div class=\"LoadVpc__form\">\n            <div class=\"LoadVpc__form-input-wrapper\">\n                <input type=\"text\" class=\"LoadVpc__form-input\" onkeyup=\"this.handleChange(event)\" onchange=\"this.handleChange(event)\" oninput=\"this.handleChange(event)\" onfocus=\"this.handleFocus()\" maxlength=\"");

    __append(escapeFn(this.vpcMaxLength));

    __append("\" value=\"");

    __append(escapeFn(this.vpcCode));

    __append("\">\n\n                ");

    if (this.hasError) {
      ;

      __append("\n                    <i class=\"IKEA--icon-alert\"></i>\n                    <div class=\"LoadVpc__form-error\">\n                        ");

      __append(escapeFn(this.translate('INVALID_CONFIGURATION_MESSAGE')));

      __append("\n                    </div>\n                ");
    }

    ;

    __append("\n            </div>\n\n            <ikea-component name=\"Button\"\n                            data-layout=\"secondary\"\n                            data-events=\"");

    __append(escapeFn(_ikeaComponentButton.default.events({
      click: this.handleClick.bind(this)
    })));

    __append("\"\n                            ");

    if (this.isLoading) {
      ;

      __append("\n                                data-icon=\"loading-spinner\"\n                                data-label=\"\"\n                                data-disabled=\"true\"\n                            ");
    } else {
      ;

      __append("\n                                data-label=\"");

      __append(escapeFn(this.translate('SPR_GALLERY_OPEN')));

      __append("\"\n                                data-disabled=\"");

      __append(escapeFn(this.vpcCode.length < this.vpcMinLength || this.hasError));

      __append("\"\n                            ");
    }

    ;

    __append("\n            ></ikea-component>\n        </div>\n\n        ");

    if (this.isKiosk()) {
      ;

      __append("\n            <ikea-component name=\"Keyboard\"\n                            data-inline=\"");

      __append(escapeFn(this.props.keyboardInline));

      __append("\"\n                            data-render-inside=\"body\">\n            </ikea-component>\n        ");
    }

    ;

    __append("\n    ");
  }

  ;

  __append("\n</div>\n");

  return __output;
}